import React, {useRef, useState, useEffect } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {contactType, listLicense} from '../../../lib/api/contact';
import {listUserClub} from "../../../lib/api/club";
import {edit, item, listPlayers} from "../../../lib/api/membership";
import AsyncSelect from "react-select/async";
import {format} from "date-fns";

export function Edit({ initMembership, initMode, onClose, onSave }) {

  console.log('initMode',initMode)
  const [club, setClub] = useState([]);
  const [item, setItem] = useState(initMembership);
  const [mode, setMode] = useState(initMode);
  const [membership, setMembership] = useState(initMembership);
  const [selectedPlayer, setSelectedPlayer] = useState([]);
  const [errors, setErrors] = useState({entities_id: false, players_entities_id: false})

  useEffect(() => {
    (async () => {
      const _clubs = await listUserClub();
      const [_player] = await listPlayers({ entities_id: initMembership.players_entities_id });
      const _rows = _clubs.map(p => ({ ...p, value: p.entities_id, label: p.name }));

      setClub(_rows);
      setSelectedPlayer({
        value: _player.entities_id,
        label: _player.name
      });
    })();
  }, [initMembership]); // ← samo kada se promijeni početni membership



  const handelInput = e => {
    const { name, value } = e.target;
    setMembership({ ...membership, [name]: value });
  };

  const loadOptions = (inputValue, callback) => {
    if (inputValue.length < 3) {
      return callback([]);
    }

    try {
      listPlayers({name:inputValue})
          .then(response => {
            const options = response.map(item => ({
              value: item.entities_id,
              label: item.name + ' ('+ formatDateTime(item.date_of_birth)+')',
            }));
            callback(options);
          }).catch(err => {
        console.error(err);
        callback([]);
      });

    } catch (error) {
      console.error(error);
      callback([]);
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // mjeseci idu od 0
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
  }

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!validateForm(event)) return;

    const _data = {
      entities_id: form.entities_id.value,
      players_entities_id: form.players_entities_id.value
    };

    console.clear();
    console.log('_data',_data)
    await edit(_data,  item.document_guid);
    onSave();
    onClose();
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      entities_id: !form.entities_id.value,
      players_entities_id: !form.players_entities_id.value,
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };


  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="entities_id">
                <Form.Label>Klub</Form.Label>
                <Form.Select name="entities_id" required value={membership.entities_id || ''} onChange={handelInput} isInvalid={errors.entities_id}  disabled={mode !== 'edit'}>
                  {club.length > 1 && (
                      <option value="">Izaberi</option>
                  )}
                  {club.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo izaberite klub.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="players_entities_id">
                <Form.Label>Igrač</Form.Label>
                <AsyncSelect name="players_entities_id"
                             cacheOptions
                             defaultOptions={false}
                             loadOptions={loadOptions}
                             placeholder="Pretraži..."
                             classNamePrefix="react-select"
                             onChange={(selected) => {
                               setSelectedPlayer(selected)
                             }}
                             value={selectedPlayer}
                             isDisabled={mode !== 'edit'}
                />
                {errors.players_entities_id && (
                    <div className="invalid-feedback d-block">
                      Molimo izaberite igrača.
                    </div>
                )}
                <Form.Control.Feedback type="invalid">Molimo izaberite klub.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="name">
                <Form.Label>Naziv</Form.Label>
                <Form.Control required type="text" name="name" value={"Promjena članstva"} disabled  />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="date_created">
                <Form.Label>Datum</Form.Label>
                <Form.Control required type="text" value={format(new Date(), 'dd.MM.yyyy')} name="date_created" disabled />
              </Form.Group>
            </Row>

            <Row className="mb-3"></Row>
            <Row className="mb-3"></Row>
            {mode === 'edit' && (
              <Button type="submit">Sačuvaj</Button>
            )}
          </Form>
        </Card.Body>
      </Card>
  );
}
